export default __webpack_public_path__ + "static/media/20210227_122627.fea06849.jpg";